import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeComplaint = gql`
    type AttachmentRef {
        _ref: String
        _type: String
    }
    
    type Attachment {
      id: ID
      name: String
      size: Int
      mimetype: String
      base64String: String
      asset: AttachmentRef
      url: String
    }

  type Complaint {
    id: ID
    applications: [ComplaintOptions]
    arrangedMeasure: String
    arrangedMeasureText: String
    attendanceAt: String
    attendanceEnd: String
    attendanceStart: String
    causeDescription: String
    changeAddress: Boolean
    charge: String
    clientCity: String
    clientEmail: String
    clientName: String
    clientPhone: String
    clientPostalCode: String
    clientStreetNumber: String
    complaintCompletedByAdm: Boolean
    contactName: String
    containerSize: String
    customerClaims: [ComplaintOptions]
    customerNumber: String
    damageDetector: String
    defects: [ComplaintOptions]
    deliveryNumber: String
    existingSubstrate: Boolean
    furtherVisit: Boolean
    givenConsultation: Boolean
    givenConsultationDate: String # Check if date can be used (2024-09-19)
    givenConsultationPerson: String
    givenConsultationType: String
    humidity: String
    mailRecipients: String
    mailSubject: String
    meetingName: String
    objectClientCity: String
    objectClientName: String
    objectClientPostalCode: String
    objectClientStreetNumber: String
    objectType: String
    otherApplicationsText: String
    otherClaimsText: String
    otherDefectsText: String
    precipitation: String
    processingPeriodFrom: String # Check if date can be used (2024-09-17)
    processingPeriodTo: String # Check if date can be used (2024-09-17)
    processorCity: String # (even though everything on screen was inputed, still was undefined)
    processorCompanyName: String # (even though everything on screen was inputed, still was undefined)
    processorCustomerNumber: String # (even though everything on screen was inputed, still was undefined)
    processorEmail: String # (even though everything on screen was inputed, still was undefined)
    processorPhone: String # (even though everything on screen was inputed, still was undefined)
    processorPostalCode: String # (even though everything on screen was inputed, still was undefined)
    processorStreetNumber: String # (even though everything on screen was inputed, still was undefined)
    recommendationRequired: Boolean
    rejectedProducts: String
    rejectedSurface: String
    sampleAvailable: Boolean
    shade: String
    structure: String
    substrate: String
    temperature: String
    text: String # (even though everything on screen was inputed, still was empty string)
    totalSurface: String
    # 1 to 1 compty from visit report, is this supposed to change or is the field really called like that?
    visitCustomer: String # Anwesender Endkunde
    visitDate: String
    visitEmployee: String
    visitLocation: Boolean
    visitProcessor: String
    emailRecipients: String
    attachmentReferences: [Attachment]
    creationAt: String
    creationBy: JSON
    modifiedAt: String
    modifiedBy: JSON
  }

  type Complaints {
    limit: Int
    offset: Int
    count: Int
    total: Int

    items: [Complaint]
  }

  type ComplaintOptions {
    name: String
    label: String
    id: ID
  }

  input ComplaintOptionsMutationValues {
    name: String
    label: String
    id: ID
  }

  input ComplaintValues {
    applications: [ComplaintOptionsMutationValues]
    arrangedMeasure: Boolean
    arrangedMeasureText: String
    attendanceAt: String
    attendanceEnd: String
    attendanceStart: String
    causeDescription: String
    changeAddress: Boolean
    charge: String
    clientCity: String
    clientEmail: String
    clientName: String
    clientPhone: String
    clientPostalCode: String
    clientStreetNumber: String
    complaintCompletedByAdm: Boolean
    contactName: String
    containerSize: String
    customerClaims: [ComplaintOptionsMutationValues]
    customerNumber: String
    damageDetector: String
    defects: [ComplaintOptionsMutationValues]
    deliveryNumber: String
    existingSubstrate: Boolean
    furtherVisit: Boolean
    givenConsultation: Boolean
    givenConsultationDate: String
    givenConsultationPerson: String
    givenConsultationType: String
    humidity: String
    mailRecipients: String
    mailSubject: String
    meetingName: String
    objectClientCity: String
    objectClientName: String
    objectClientPostalCode: String
    objectClientStreetNumber: String
    objectType: String
    otherApplicationsText: String
    otherClaimsText: String
    otherDefectsText: String
    precipitation: String
    processingPeriodFrom: String
    processingPeriodTo: String
    processorCity: String # (even though everything on screen was inputed, still was undefined)
    processorCompanyName: String # (even though everything on screen was inputed, still was undefined)
    processorCustomerNumber: String # (even though everything on screen was inputed, still was undefined)
    processorEmail: String # (even though everything on screen was inputed, still was undefined)
    processorPhone: String # (even though everything on screen was inputed, still was undefined)
    processorPostalCode: String # (even though everything on screen was inputed, still was undefined)
    processorStreetNumber: String # (even though everything on screen was inputed, still was undefined)
    recommendationRequired: Boolean
    rejectedProducts: String
    rejectedSurface: String
    sampleAvailable: Boolean
    shade: String
    structure: String
    substrate: String
    temperature: String
    text: String # (even though everything on screen was inputed, still was empty string)
    totalSurface: String
    # 1 to 1 compty from visit report, is this supposed to change or is the field really called like that?
    visitCustomer: String # Anwesender Endkunde
    visitDate: String # Check if date can be used (2024-09-17)
    visitEmployee: String # Anwesender einzA Mitarbeiter
    visitLocation: Boolean
    visitProcessor: String
    emailRecipients: String
    attachmentReferences: [AttachmentMutationValues]
    deletedAttachmentReferences: [AttachmentMutationValues]
    modifiedAt: String
    modifiedBy: JSON
  }

  type Query {
    complaint(
      lang: String = ""
      cdn: Boolean = false
      id: ID
    ): Complaint

    complaints(
      lang: String = ""
      cdn: Boolean = false
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      sortWithinLimits: Boolean = false
      year: String
      defectId: ID
      customerNumber: String
    ): Complaints

    complaintAvailableDefects: [ComplaintOptions]
    complaintAvailableApplications: [ComplaintOptions]
    complaintCustomerClaims: [ComplaintOptions]
  }

  type Mutation {
    createComplaint(
      customerId: ID
      customerNumber: String
      lang: String = ""
      cdn: Boolean = false
      values: ComplaintValues
    ): Complaint

    updateComplaint(
      customerId: ID
      customerNumber: String
      lang: String = ""
      cdn: Boolean = false
      values: ComplaintValues
      id: ID
    ): Complaint

    deleteComplaint(lang: String = "", cdn: Boolean = false, id: ID): Boolean
  }
`

export { typeComplaint }
export default typeComplaint
